import React, { useEffect } from "react";
import { DatePicker, Form, Input, Select } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import Icons from "components/icons";
import { Localize } from "components/service";
import StaffManagementForms from "../forms";


const { RangePicker } = DatePicker;
const { Search } = Input;

const StaffAuditLogTableFilter = ({
    searchText,
    setSearchText,
    period,
    setPeriod,
    subcontractorID,
    setSubcontractorID,
    result,
    setResult,
    action,
    setAction,
    resetPage,
}) => {
    const [ form ] = Form.useForm();
    const hasPeriod = !!period?.length;
    const hasSubcontractor = !!subcontractorID;
    const searchWorkerLabel = Localize({ children: "STAFF_MANAGEMENT.Filter_SearchWorker" }).props.children;
    const selectPeriodLabel = Localize({ children: "STAFF_MANAGEMENT.Filter_SelectPeriod" }).props.children;
    const resultLabel = Localize({ children: "STAFF_MANAGEMENT.Filter_Result" }).props.children;
    const actionTypeLabel = Localize({ children: "STAFF_MANAGEMENT.Filter_ActionType" }).props.children;

    useEffect(() => {
        form.setFieldsValue({ subcontractor_id: subcontractorID });
    }, [ form, subcontractorID ]);

    const selectOptions = (values, prefix) => values.map((value) => ({
        value,
        label: <Localize>{ `STAFF_MANAGEMENT.${ prefix }_${ value }` }</Localize>,
    }));

    return (
        <Form form={ form } component={ false }>
            <div className="d-flex align-items-center table-action-bar form-controls-compact staff-table-filter">
                <div className="d-flex align-items-center table-filter-form staff-table-filter__controls">
                    <Search
                        allowClear={ { clearIcon: <CloseOutlined /> } }
                        aria-label={ searchWorkerLabel }
                        className="filter-search"
                        prefix={ <SearchOutlined /> }
                        placeholder={ searchWorkerLabel }
                        value={ searchText }
                        onChange={ (event) => {
                            setSearchText(event.target.value);
                            resetPage();
                        } } />

                    <RangePicker
                        allowClear
                        clearIcon={ <CloseOutlined /> }
                        className={ `staff-audit-filter__period${
                            hasPeriod ?
                                " staff-audit-filter__period--chosen staff-filter-control--selected" :
                                " range-picker-single-placeholder"
                        }` }
                        format="DD.MM.YYYY"
                        separator="—"
                        suffixIcon={ hasPeriod ? null : <Icons.StaffCalendar /> }
                        placeholder={ [ selectPeriodLabel, "" ] }
                        value={ hasPeriod ? period : undefined }
                        onChange={ (value) => {
                            setPeriod(value || []);
                            resetPage();
                        } } />

                    <StaffManagementForms.Fields.AuditSubcontractorSelect
                        form={ form }
                        selected={ hasSubcontractor }
                        onChange={ (value) => {
                            setSubcontractorID(value);
                            resetPage();
                        } } />

                    <Select
                        allowClear
                        aria-label={ resultLabel }
                        className={ `staff-audit-filter__result${
                            result ? " staff-filter-control--selected" : ""
                        }` }
                        clearIcon={ <CloseOutlined /> }
                        dropdownClassName="staff-audit-filter__dropdown"
                        options={ [
                            { value: "ACCEPTED", label: <Localize>STAFF_MANAGEMENT.AuditResult_accepted</Localize> },
                            { value: "REJECTED", label: <Localize>STAFF_MANAGEMENT.AuditResult_rejected</Localize> },
                            { value: "IGNORED", label: <Localize>STAFF_MANAGEMENT.AuditResult_ignored</Localize> },
                        ] }
                        placeholder={ resultLabel }
                        suffixIcon={ result ? null : <Icons.Arrow /> }
                        value={ result }
                        onChange={ (value) => {
                            setResult(value);
                            resetPage();
                        } } />

                    <Select
                        allowClear
                        aria-label={ actionTypeLabel }
                        className={ `staff-audit-filter__action${
                            action ? " staff-filter-control--selected" : ""
                        }` }
                        clearIcon={ <CloseOutlined /> }
                        dropdownClassName="staff-audit-filter__dropdown"
                        options={ selectOptions([ "check_in", "check_out" ], "AuditAction") }
                        placeholder={ actionTypeLabel }
                        suffixIcon={ action ? null : <Icons.Arrow /> }
                        value={ action }
                        onChange={ (value) => {
                            setAction(value);
                            resetPage();
                        } } />
                </div>
            </div>
        </Form>
    );
};

export default StaffAuditLogTableFilter;
